import { render, staticRenderFns } from "./CopyableLink.vue?vue&type=template&id=23f5701a"
import script from "./CopyableLink.ts?vue&type=script&lang=ts&external"
export * from "./CopyableLink.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports